import classNames from "classnames";
import { twMerge } from "tailwind-merge";

/**
 * `classnames` + conflict resolution, for `components/ui` primitives that ship default utilities.
 * A caller's `className="mb-0"` must beat a primitive's built-in `mb-[0.5em]`; plain `classnames`
 * would emit both and let stylesheet order decide. App code keeps using `classnames` directly.
 */
export const cn = (...args: classNames.ArgumentArray): string => twMerge(classNames(...args));
